import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import Indentation from '../../../../components/Simple/Indentation';
import {SMCRadioGroup, SMCRadio} from '../../../../components/Simple/SMCRadio';
import {ServiceDomainGetSchema} from '../../../../api/DBSchema/ServiceDomain';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import SMCNumberInput from "../../../../components/Simple/SMCNumberInput";
import SMCIcon from "../../../../components/Simple/SMCIcon";
import EmptyRow from '../../../../components/Simple/EmptyRow';

const pageSchema = ServiceDomainGetSchema.pages.general;
const pageId = pageSchema.pageId;

function ServiceDomainGeneral({
    serviceDomainObject,
    setServiceDomainData
}) {
    const { t } = useTranslation();

    const pageData = serviceDomainObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setServiceDomainData([pageId, paramName], value);
    }, [setServiceDomainData]);

    const description                     = pageData[pageSchema.description];
    const isEnabled                       = pageData[pageSchema.isEnabled];
    const company                         = pageData[pageSchema.company];
    const contact                         = pageData[pageSchema.contact];
    const email                           = pageData[pageSchema.email];
    const serverGroupName                 = pageData[pageSchema.serverGroupName];
    const availableServerGroups           = pageData[pageSchema.availableServerGroups];
    const customHeartbeatInterval         = pageData[pageSchema.customHeartbeatInterval];
    const defaultHeartbeatInterval        = pageData[pageSchema.defaultHeartbeatInterval];

    var heartbeatIntervalType;
    if (pageData[pageSchema.heartbeatIntervalType]) {
        heartbeatIntervalType = pageData[pageSchema.heartbeatIntervalType];
    }
    else {
        heartbeatIntervalType = (!!customHeartbeatInterval ? pageSchema.heartbeatIntervalTypeValues.custom : pageSchema.heartbeatIntervalTypeValues.defult);
        pageData[pageSchema.heartbeatIntervalType] = heartbeatIntervalType;
    }
                                            
    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.LINE1')}</SMCLabel>
            <SMCTextInput
                label={t('SMP.DESCRIPTION')}
                value={description}
                onChange={e => setPageValue(pageSchema.description, e.target.value)}
            />
            <SMCCheckbox
                label={t('SMP.ENABLED')}
                labelPosition="start"
                checked={isEnabled}
                onChange={e => setPageValue(pageSchema.isEnabled, e.target.checked)}
            />
            <SMCTextInput
                label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.COMPANY')}
                value={company}
                onChange={e => setPageValue(pageSchema.company, e.target.value)}
            />
            <SMCTextInput
                label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.CONTACT')}
                value={contact}
                onChange={e => setPageValue(pageSchema.contact, e.target.value)}
            />
            <SMCTextInput
                label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.EMAIL')}
                value={email}
                onChange={e => setPageValue(pageSchema.email, e.target.value)}
            />
            <SMCSelect
                label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.SERVER_GROUP')}
                value={serverGroupName || ""}
                onChange={e => setPageValue(pageSchema.serverGroupName, e.target.value === '' ? null : e.target.value)}
            >
                {
                    <>
                    <SMCOption value="" />
                    {
                        availableServerGroups && availableServerGroups.map(serverGroupName => (
                            <SMCOption key={serverGroupName} value={serverGroupName}>{serverGroupName}</SMCOption>
                        ))

                    }
                    </>
                }
            </SMCSelect>
            <EmptyRow/>
            <SMCLabel bold>{t('SMP.SETTINGS.GENERAL.GW_KEEP_ALIVE_INT')}</SMCLabel>
            <SMCRadioGroup value={heartbeatIntervalType} onChange={e => setPageValue(pageSchema.heartbeatIntervalType, e.target.value)}>
                <SMCRadio value={pageSchema.heartbeatIntervalTypeValues.defult} label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.HEARTBEAT_INTERVAL.DEFAULT')} />
                {
                        <Indentation>
                            <SMCNumberInput disabled={true} value={defaultHeartbeatInterval} />
                        </Indentation>
                }
                <SMCRadio value={pageSchema.heartbeatIntervalTypeValues.custom} label={t('SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.HEARTBEAT_INTERVAL.CUSTOM')} />
                {
                       <Indentation>
                            <SMCNumberInput value={customHeartbeatInterval} onChange={e => setPageValue(pageSchema.customHeartbeatInterval, e.target.value)} />
                      </Indentation>
                }
            </SMCRadioGroup>
            <SMCLabel>
                 <SMCIcon icon="info" /> {t("SMP.SYSTEM.SERVICE_DOMAINS.GENERAL.LINE2")}
            </SMCLabel>

        </EditorLayout>
    )
}

export default ServiceDomainGeneral;